/* eslint eqeqeq: 0 */
import { useTheme } from "@emotion/react";
import { ArrowRightAltOutlined, Done } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Checkbox,
  Divider,
  Rating,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import slugify from "slugify";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import toast from "react-hot-toast";
import { t } from "i18next";
import api from "../../../API/apiCollection";
import { useSelector, useDispatch } from "react-redux";
import { setBookmark } from "../../../redux/Bookmark";
import { placeholderImage } from "../../../util/Helper";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const Partner = ({ partner, isHome = false }) => {
  if (partner.number_of_ratings) {
    partner.number_of_ratings = parseInt(partner.number_of_ratings);
  }
  const authentication = useSelector(
    (state) => state.authentication
  )?.isLoggedIn;
  const theme = useTheme();
  const locationData = useSelector((state) => state.Location);
  const lat = locationData.lat;
  const lng = locationData.lng;
  const slug = slugify(partner.company_name, {
    lower: true, // Convert the slug to lowercase
  });
  const settings = useSelector((state) => state.Settings)?.settings;
  const currency_symbol = settings?.app_settings?.currency;

  const partner_id =
    partner.partner_id !== undefined ? partner.partner_id : partner.id;

  const dispatch = useDispatch();
  const marked = useSelector((state) => state.Bookmark);

  const handle = async (item) => {
    try {
      // Ensure marked.bookmark is an array
      const bookmarks = marked?.bookmark ?? [];

      const isBookmarked1 = bookmarks.some(
        (bookmark) => bookmark.partner_id === item.partner_id
      );

      if (isBookmarked1) {
        dispatch(
          setBookmark(
            marked.bookmark.filter(
              (bookmark) => bookmark.partner_id !== item.partner_id
            )
          )
        );
      } else {
        const newMark = { partner_id: item.partner_id };
        let updatedMarkedArray = [...bookmarks, newMark];
        dispatch(setBookmark(updatedMarkedArray));
      }

      if (authentication) {
        const response = await api.bookmark({
          type: isBookmarked1 ? "remove" : "add",
          lat: lat,
          lng: lng,
          partner_id: item.partner_id !== undefined ? item.partner_id : item.id,
        });
        if (response && response.data) {
          toast.success(response.message);
        } else {
          dispatch(
            setBookmark(
              marked.bookmark.filter(
                (bookmark) => bookmark.partner_id !== item.partner_id
              )
            )
          );
        }
      }
    } catch (error) {
      console.error("Error handling bookmark:", error);
    }
  };

  const isBookmarked =
    marked &&
    marked.bookmark &&
    marked.bookmark.some(
      (bookmark) => bookmark.partner_id === partner.partner_id
    );

  let ratingLabel = "";
  const avg_rating = parseInt(partner.ratings ?? partner.average_rating);
  if (avg_rating >= 0 && avg_rating < 3 || isNaN(avg_rating)) {
    ratingLabel = "Low";
  } else if(avg_rating >= 3 && avg_rating < 4) {
    ratingLabel = "High";
  } else if(avg_rating >= 4) {
    ratingLabel = "Superb";
  }

  return (
    <div className="item">
        <div className="strip">
            <figure>
            <div className='cover animate' style={{backgroundImage: "url(" + partner.image + ")"}}>
                <img onError={placeholderImage} src={partner.image} data-src={partner.image} style={{backgroundImage: "url(" + partner.image + ")"}} class="owl-lazy invisible" alt="" />
            </div>
                {partner.discount > 0? <span className="ribbon off">{partner.discount_type == "amount" ? currency_symbol + " " + partner.discount : partner.discount + " %"}</span> : null}
                <a href={`/stores/services/${partner_id}/${slug}`} className="strip_info">
                    <small style={{backgroundColor: `${partner.category_light_color}`}}>{partner.category}</small>
                    <div className="item_title">
                        <h3>{partner.company_name}</h3>
                        <small>{partner.city}</small>
                        {/*<small>Istanbul, Turkey</small>*/}
                    </div>
                </a>
            </figure>
            <ul>
               
                <li>
                    <div className="score"><span>{ratingLabel}<em>{partner.number_of_rating} Review(s)</em></span><strong><FontAwesomeIcon icon={faStar} size="1x" />&nbsp;{isNaN(avg_rating)? "0.0" : (typeof avg_rating === 'string' || avg_rating instanceof String)? parseFloat(avg_rating).toFixed(1) : avg_rating.toFixed(1)}</strong></div>
                </li>
            </ul>
        </div>
    </div>
  );

  return (
    <Card
      key={partner.id}
      mb={{ xs: "10px", md: 5 }}
      sx={{
        my: { xs: "10px", md: 0 },
        borderRadius: "var(--global-border-radius)",
        position: "relative",
      }}
    >
      <Box display={"flex"} className="serviceBookMarkBox">
        {isHome === false && authentication === true ? (
          <Checkbox
            key={partner.id}
            size="small"
            {...label}
            id={partner.id}
            checked={isBookmarked}
            sx={{ color: "white" }}
            icon={
              <BookmarkBorderIcon
                sx={{ color: theme?.palette?.primary?.main }}
              />
            }
            checkedIcon={
              <BookmarkIcon sx={{ color: theme?.palette?.primary?.main }} />
            }
            onClick={(event) => {
              event.stopPropagation();
              handle(partner);
            }}
          />
        ) : (
          ""
        )}
      </Box>

      <Link
        key={partner.id}
        to={`/stores/services/${partner_id}/${slug}`}
        className="breadcrumb text-light"
      >
        <img
          alt="partner"
          src={partner.banner_image}
          onError={placeholderImage}
          className="partner_image"
        />

        <Box
          className="partner-cardmedia"
          p={"5px"}
          sx={{ bgcolor: "white", borderColor: theme?.palette?.primary?.main }}
        >
          <CardMedia
            image={partner.image}
            alt={partner.company_name}
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
            }}
          />
        </Box>

        <Box textAlign={"center"} sx={{ margin: "auto", width: "100%" }}>
          <CardContent sx={{ pb: "0!important", px: "0!important" }}>
            <Typography
              variant="h5"
              component="div"
              textAlign={"center"}
              color={theme.palette.color.navLink}
            >
              {partner.company_name}
            </Typography>

            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={1}
            >
              <Box display={"flex"} alignItems={"center"} gap={1}>
                <Rating
                  name="read-only"
                  value={parseInt(partner.ratings ?? partner.average_rating)}
                  readOnly
                  className="aling-content"
                />
                <Typography
                  variant="body1"
                  color={theme.palette.color.textColor}
                >
                  (
                  {partner.ratings && partner.ratings !== ""
                    ? parseFloat(partner.ratings).toFixed(1)
                    : partner.number_of_rating === "0"
                    ? "0"
                    : "0"}{" "}
                  / 5)
                </Typography>
              </Box>

              <Button
                size="small"
                sx={{ borderRadius: "8px", textTransform: "none" }}
                variant="contained"
                startIcon={
                  <Done
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "50%",
                      color: theme?.palette?.primary?.main,
                    }}
                  />
                }
              >
                <Box display={"flex"} gap={0.5}>
                  <Box>{partner.number_of_orders}</Box>
                  <Box>{t("order_completed")}</Box>
                </Box>
              </Button>
            </Box>

            <Divider sx={{ mt: 2 }} />

            <CardActionArea
              sx={{
                height: "100%",
                transition: "ease-in",
                "&:hover": {
                  backgroundColor: theme?.palette?.primary?.main,
                  color: "white",
                  "& .MuiBox-root": {
                    color: "white",
                  },
                  // Other CSS properties for the hover effect
                },
              }}
            >
              <Box
                color={theme.palette.color.navLink}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                  width: "100%",
                  height: "100%",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  fontWeight: 700,
                }}
              >
                {t("view_all_services")} <ArrowRightAltOutlined />
              </Box>
            </CardActionArea>
          </CardContent>
        </Box>
      </Link>
    </Card>
  );
};

export default Partner;
